"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var SearchTrigger = /** @class */ (function (_super) {
    __extends(SearchTrigger, _super);
    function SearchTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchTrigger.prototype.render = function () {
        var _a = this.props, searchOpen = _a.searchOpen, onOpen = _a.onOpen;
        return (React.createElement("button", { onClick: function (event) { return onOpen(); }, className: "relative w-1/2 flex-grow block lg:hidden flex justify-start items-center py-1-4 text-navy-dark transition-fast border-0 pr-1-6 pl-3-2 text-left focus:outline-none transition-fast " + (searchOpen ? "invisible translate-y:-100 transition-delay-0" : "visible translate-y:0 transition-delay-5") },
            React.createElement(Snippets.Svg, { name: "search", width: 14, className: "block" }),
            React.createElement("p", { className: "text-sm ml-0-8 font-medium" }, "Search the range")));
    };
    return SearchTrigger;
}(React.PureComponent));
exports.SearchTrigger = SearchTrigger;
